export default __webpack_public_path__ + "images/83079b4f5dd9305720cddfba5b614445-4_web_1919x543.jpg";